import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
//import Image from '../../Image/Image' // react-image-resizer   -/- reactjs-image-resizer
import { cloneDeep, each } from 'lodash';
import {arrayMoveImmutable as arrayMove} from 'array-move';

import { sortableContainer, sortableElement } from 'react-sortable-hoc';
//import { sortableHandle } from 'react-sortable-hoc'; // for dragable and sort element

import apiUrls from '../../../apiUrls';
import { FIELD_VALIDATION_ERROR_TYPES } from '../../../utils/constants';

import Caption from '../../Caption/Caption';
import EditLabelError from '../EditLabelError/EditLabelError';
import EditLabelText from '../EditLabelText/EditLabelText';
import FileUpload from '../../FileUpload/FileUpload';
import PreviewRemove from '../PreviewRemove/PreviewRemove';
//import Mplayer from '../../Mplayer/Mplayer'; // we used another player
import AudioPlayer from './AudioPlayer/AudioPlayer';

import {
    EDIT_UPLOAD_COMMON_ERROR,
    EDIT_UPLOAD_INVALID_FILE_DIMENSION_ERROR,
    EDIT_UPLOAD_INVALID_FILE_SIZE_ERROR,
    EDIT_UPLOAD_INVALID_FILE_TYPE_ERROR,
} from '../../../translations';

import {
    EDIT_VOICEOVER_FILE_FORMAT,
    EDIT_VOICEOVER_FILE_SIZE,
    EDIT_VOICEOVER_LABEL_TEXT,
    EDIT_VOICEOVER_LABEL,
} from './translations'

import styles from './EditVoiceover.module.css';


const MAX_VOICEOVER_ITEMS = 5 // 5

export default class EditVoiceover extends React.PureComponent {
    static propTypes = {
        externalItems: PropTypes.arrayOf(PropTypes.shape({
            position: PropTypes.number.isRequired,
            //fileId: PropTypes.number.isRequired,
            voiceoverId: PropTypes.number.isRequired,
            source: PropTypes.string.isRequired,
            sourceOriginalName: PropTypes.string,
        })),
        onVoiceoversChange: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            errorType: null,
            items: [],
        }
    }

    UNSAFE_componentWillMount() {
        if (this.props.externalItems) {
            this.setState({
                items: this.props.externalItems,
            })
        }
    }

    handleRemoveVoiceover = (position) => {
        const items = this.state.items
            .filter((item) => item.position !== position)
            .map((item, index) => ({ ...item, position: index }))
        this.setState({ items })
        this.props.onVoiceoversChange(items)
    }

    handleSort = ({ oldIndex, newIndex }) => {
        this.setState(({ items }) => ({
            items: arrayMove(items, oldIndex, newIndex),
        }))

        this.props.onVoiceoversChange(this.state.items)
    }

    handleUploadCompleted = (data, errorType) => {
        const items = cloneDeep(this.state.items)
        each(data, (dataItem) => {
            if (items.length >= MAX_VOICEOVER_ITEMS) {
                return
            }
            items.push({
                accessToken: dataItem.access_token,
                fileId: dataItem.id,
                position: items ? items.length : 0,
                source: dataItem.source,
                sourceOriginalName: dataItem.source_original_name,
                title: dataItem.source_original_name, // duplicate sourceOriginalName
            })
        })

        this.setState({ errorType, items })
        this.props.onVoiceoversChange(items)
    }

    renderVoiceover(position, source, sourceOriginalName, isDraggable) { // fileId sourceOriginalName
        // for dragable element
        /*const DragHandle = sortableHandle(({ children }) => (
            <div>{children}</div>
        ))*/

        const classNameVoiceover = classNames(styles.voiceover, {
            [styles.isDraggable]: false, // isDraggable
        })

        //let sourceOriginalName = source.slice(38).slice(0, 14)+'.wav'; // создаем, т.к. мы его не получаем с сервера

        let srcAudio = [];
        srcAudio.push({
            //id: fileId, 
            id: position,
            url: source
        });
        
        return (
            <div className={classNameVoiceover} key={position}>
                {/* <DragHandle>
                    <div className={styles.audio}>
                        <AudioPlayer 
                            timeFormat="mm:ss" // hh:mm:ss
                            volume={1.0}
                            title={sourceOriginalName}
                            src={srcAudio} 
                        />
                    </div>
                </DragHandle> */}

                <div className={styles.audio}>
                    {/* player for audio file */}
                    <AudioPlayer 
                        timeFormat="mm:ss" // hh:mm:ss
                        volume={1.0}
                        title={sourceOriginalName}
                        src={srcAudio} 
                    />
                </div>
                <div className={styles.previewRemove}>
                    <PreviewRemove onClick={() => {this.handleRemoveVoiceover(position)}} />
                </div>
            </div>
        )
    }

    renderErrorLabel() {
        const errorToMessagesMapping = {
            [FIELD_VALIDATION_ERROR_TYPES.COMMON_ERROR]: EDIT_UPLOAD_COMMON_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR]: EDIT_UPLOAD_INVALID_FILE_SIZE_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR]: EDIT_UPLOAD_INVALID_FILE_TYPE_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.NOT_SUPPORTED_IMAGE_DIMENSIONS]: EDIT_UPLOAD_INVALID_FILE_DIMENSION_ERROR,
        }
        return this.state.errorType ? (
            <EditLabelError message={errorToMessagesMapping[this.state.errorType]} />
        ) : null
    }

    renderVoiceovers() {
        const SortableItem = sortableElement(({ value }) => (
            <div className={styles.item}>{value}</div>
        ))

        const SortableContainer = sortableContainer(({ children }) => (
            <div className={styles.voiceovers}>{children}</div>
        ))

        const isDraggable = this.state.items.length > 1

        const items = this.state.items.map((item) => (
            this.renderVoiceover(item.position, item.source, item.title, isDraggable)
        ))
        
        return (
            <SortableContainer
                helperClass={styles.dragged} // "dragged"
                axis="xy"
                useDragHandle
                onSortEnd={this.handleSort}
            >
                {items.map((value, index) => (
                    <SortableItem
                        key={`item-${index}`}
                        index={index}
                        value={value}
                        disabled={!isDraggable}
                    />
                ))}
            </SortableContainer>
        )
    }

    renderFileUpload() {
        if (this.state.items.length >= MAX_VOICEOVER_ITEMS) {
            return null
        }

        const isErrorFileFormat = this.state.errorType === FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR
        const isErrorFileSize = this.state.errorType === FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR

        const url = `https://tankimods.net${apiUrls.modAudioUpload}`; // apiUrls.modAudioUpload
        //const url = `https://tankimods.net${apiUrls.modVoiceoverUpload}`// apiUrls.modVoiceoverUpload
        // const url = `https://tankimods.net${apiUrls.modFileUpload}` // apiUrls.modFileUpload

        return (
            <FileUpload
                isReplacementDisabled
                isMultiple
                fieldName="source"
                summary={(
                    <span>
                        <span className={styles.fileUploadSummary}>
                            {EDIT_VOICEOVER_FILE_FORMAT(isErrorFileFormat)}
                        </span>
                        <span className={styles.fileUploadSummary}>
                            {EDIT_VOICEOVER_FILE_SIZE(isErrorFileSize)}
                        </span>
                    </span>
                )}

                voiceover={true} // for prelistening audio

                url={url}
                onUploadCompleted={this.handleUploadCompleted}
            />
        )
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption isLarge>
                        {EDIT_VOICEOVER_LABEL}
                    </Caption>
                    <EditLabelText message={EDIT_VOICEOVER_LABEL_TEXT} />
                    {this.renderErrorLabel()}
                </div>
                <div className={styles.field}>
                    {this.renderVoiceovers()}
                    {this.renderFileUpload()}
                </div>
            </div>
        )
    }
}
